import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-qrcodes-pdf-dialog',
  templateUrl: './qrcodes-pdf-dialog.component.html',
  styleUrls: ['./qrcodes-pdf-dialog.component.scss']
})
export class QrcodesPdfDialogComponent {
  path: any;
  constructor(
    public config: DynamicDialogConfig
  ) {
    this.path = this.config.data.path;
  }
}
